import { DatePipe, DecimalPipe } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DirectivesModule } from 'app/shared/directives/directives.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { SharedModule } from 'app/shared/shared.module';
import { includeBearerTokenInterceptor, KeycloakAngularModule } from 'keycloak-angular';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { NavigationDataGuard } from './guards/navigation-data-guard';
import { keycloakInitializer } from './utils/app-init';
import { graphqlProvider } from './utils/apollo-init';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MissingTranslationHandler, provideTranslateService, TranslateModule, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  FeComponentLibraryModule,
  FixedTimeRangeSelectionService,
  ThemeModule,
  ThemeService
} from '@wind-log_library/fe-component-library';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { DataStudioRedesignModule } from './data-studio-redesign/data-studio-redesign.module';
import { PaginatorIntlService } from './shared/services/paginator-int-service/paginator-int-service';
import { themeConfig } from './shared/services/theme-colors/theme.config';
import { LogMissingTranslationHandler } from './utils/log-missing-translation-handler';
import { HighchartsChartModule } from 'highcharts-angular';
import { UnitsService as SharedUnitsService } from '@wind-log_library/fe-component-library';
import { UnitsService } from './shared/services/units/units.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { LanguageService } from './shared/services/language/language.service';
import { GlobalErrorHandler } from './utils/error-handler';
import { LogoutService } from './shared/services/logout-service/logout.service';
import { MatMenuModule } from '@angular/material/menu';

LanguageService.registerLocales();


@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    PipesModule,
    DirectivesModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    SharedModule,
    ThemeModule.forRoot(themeConfig),
    DataStudioRedesignModule,
    FeComponentLibraryModule,
    PopoverModule.forRoot(),
    ReactiveFormsModule,
    NgbTooltipModule,
    HighchartsChartModule,
    MatSidenavModule,
    MatMenuModule,
    TranslateModule,
    KeycloakAngularModule
  ],
  providers: [
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor])),
    keycloakInitializer(),
    graphqlProvider,
    {
      provide: MatPaginatorIntl,
      useFactory: (translate) => {
          const service = new PaginatorIntlService(translate);
          service.injectTranslateService();
          return service;
      },
      deps: [TranslateService]
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
      deps: [TranslateService, ThemeService, LogoutService]
    },
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json'
      }),
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: LogMissingTranslationHandler },
    }),
    { 
      provide: 'environment',
      useValue: environment
    },
    ThemeService,
    NavigationDataGuard,
    FixedTimeRangeSelectionService,
    DecimalPipe,
    DatePipe,
    {
      provide: SharedUnitsService,
      useExisting: UnitsService
    },
  ] })

export class AppModule { }

